/* eslint-disable no-shadow */
import Vue from 'vue';
import Vuex from 'vuex';
import { apiTranslations, addMissingTranslation } from '@/api/translations';

Vue.use(Vuex);

const state = {
  translations: null,
  config: null,
  language: null,
};

const getters = {
  translations: state => state.translations,
  config: state => state.config,
  language: state => state.language,
  displayName: state => (state.config.displayName ? state.config.displayName : state.config.name),
};

const mutations = {
  setTranslations(state, translations) {
    state.translations = translations;
  },
  setConfig(state, config) {
    state.config = config;
  },
  setLanguage(state, language) {
    state.language = language;
  },
  addTranslation(state, key, defaultValue) {
    state.translations[key] = defaultValue;
  },
};

const actions = {
  getTranslations({ commit, state }) {
    if (state.language && !state.translations) {
      apiTranslations(state.config.key, state.config.endpoint, state.language, state.config.translationApiEndpoint).then((response) => {
        commit('setTranslations', response.data);
      });
    }
  },
  addMissingTranslation({ commit, state }, payload) {
    addMissingTranslation(state.config.key, state.config.endpoint, 'en', payload.key, payload.defaultValue, state.config.translationApiEndpoint).then(() => {
      commit('addTranslation', payload.key, payload.defaultValue);
    });
  },
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});



// WEBPACK FOOTER //
// ./src/store/index.js